import React, { useEffect, useState, useCallback } from "react";
import CommonLayout from "../layout/CommonLayout";
import CommonMenu from "../layout/CommonMenu";
import CommonFooter from "../layout/CommonFooter";
import { Link } from 'react-router-dom';
import Slider from "react-slick";

export default function MainPag() {
  const [companyInfo, setCompanyInfo] = useState("");

  useEffect(() => {
    // 메인테스트      
    const hostname = window.location.hostname;
    if (hostname.includes("gnbsoftec.co.kr")) {
      setCompanyInfo("(주)지앤비소프텍");
    } else if (hostname.includes("puresolution.co.kr")) {
      setCompanyInfo("(주)퓨어솔루션");
    } else {
      setCompanyInfo("(주)퓨어솔루션");
    }
    
  }, []);

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div>
      <button className='bullet_left'>Prev</button>
     </div>
    );
  };

  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div>
        <button className='bullet_right' >Next</button>
      </div>
      
    );
  };

  const AcSliderMain = () => {
    const settings = {
      slidesToShow: 1, // 한 번에 보여줄 슬라이드 개수
      slidesToScroll: 1, // 한 번에 넘길 슬라이드 개수
      edgeFriction: 1, // 가장자리에 닿았을 때의 마찰력
      dots: true, // 페이지네이션 점 활성화
      arrows: false, // 기본 화살표 제거
      infinite: true, // 무한 반복
      prevArrow : <PrevArrow />,
		  nextArrow : <NextArrow />,
      autoplay: true, // 자동 재생
      autoplaySpeed: 2000, // 자동 재생 속도
      speed: 400, // 슬라이드 전환 속도
      pauseOnHover: true, // 마우스 호버 시 정지
      lazyLoad: "ondemand", // 필요할 때 로드
      draggable: true, // 드래그 가능 여부
      centerMode: true, // 가운데 정렬
      centerPadding: "0px", // 중앙 패딩
      focusOnSelect: true, // 선택한 슬라이드 포커스
      adaptiveHeight: false, // 각 슬라이드에 맞춰 자동으로 높이 조정
      variableWidth: false, // 슬라이드 개별 너비 자동 조정 (true로 설정하면 너비가 이미지 크기에 따라 달라짐)
    };

    return (
      <Slider {...settings}>

        <div className="main_banner01-1">
          <img className="w-full" src="/asset/img/main/main_video_new.gif"/>
          <div className="inner main-textbox" style={{ color: "black" }}>
            <p>최고의 기술로 즐거운 IT세상을 만들어가는<br /><span>지앤비소프텍 입니다</span></p>
            <p>GnB는 금융 전문회사 입니다.<br />GnB는 개발인력을 소중히 여깁니다.</p>
          </div>
        </div>

        <div className="main_banner01-2">
          <img className="w-full" src="../../asset/pure/img/main/main-bg.png" alt="메인 배경이미지" />
          <div className="inner main-textbox">
            <p>최고의 기술로 즐거운 IT세상을 만들어가는<br /><span>퓨어솔루션 입니다</span></p>
            <p>퓨어솔루션은 금융 전문회사 입니다.<br />퓨어솔루션은 개발인력을 소중히 여깁니다.</p>
          </div>
        </div>

      </Slider>
    );
  };

  const AcSlider01 = () => {
    const settings = {
      slidesToShow: 1, // 한 번에 보여줄 슬라이드 개수
      slidesToScroll: 1, // 한 번에 넘길 슬라이드 개수
      edgeFriction: 1, // 가장자리에 닿았을 때의 마찰력
      dots: true, // 페이지네이션 점 활성화
      arrows: false, // 기본 화살표 제거
      infinite: true, // 무한 반복
      prevArrow : <PrevArrow />,
		  nextArrow : <NextArrow />,
      autoplay: true, // 자동 재생
      autoplaySpeed: 2000, // 자동 재생 속도
      speed: 400, // 슬라이드 전환 속도
      pauseOnHover: true, // 마우스 호버 시 정지
      lazyLoad: "ondemand", // 필요할 때 로드
      draggable: true, // 드래그 가능 여부
      centerMode: true, // 가운데 정렬
      centerPadding: "0px", // 중앙 패딩
      focusOnSelect: true, // 선택한 슬라이드 포커스
    };

    return ( 
      <Slider {...settings}>
            
        <div className="main_banner01-1">
          <div>
            <div className="inner">
              <div className="box-text">
              <h3 className="tit-main01">시스템통합(SI)</h3>
                <Link to="GNBPURE01001S">
                상세보기 &gt;
                </Link>
                <ul className="text-info">
                  <li>고객의 전략적 목표달성</li>
                  <li>환경에 적합한 최적의 시스템 구축</li>
                  <li>보유솔루션+전문가그룹 강점의 유기적 결합</li>
                </ul>
              </div>
            </div>
          </div>
          
        </div>

        <div className="main_banner01-2">
          <div>
            <div className="inner">
              <div className="box-text">
                <h3 className="tit-main01">시스템유지보수(SM)</h3>
                <Link to="GNBPURE01002S">
                상세보기 &gt;
                </Link>
                <ul className="text-info">
                  <li>비용과 리스크의 감소</li>
                  <li>안정적인 시스템 운영</li>
                  <li>트렌드에 맞춘 컨설팅</li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <div className="main_banner01-3">
          <div>
            <div className="inner">
              <div className="box-text">
                <h3 className="tit-main01">솔루션</h3>
                <Link to="GNBPURE01003S">
                상세보기 &gt;
                </Link>
                <ul className="text-info">
                  <li>돌핀 금융정보 솔루션</li>
                  <li>고객사의 요구에 최적화된 맞춤 솔루션 제공</li>
                  <li>금융업무에 필요한 솔루션 제공</li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <div className="main_banner01-4">
          <div>
            <div className="inner">
              <div className="box-text">
                <h3 className="tit-main01">애플리케이션서비스(ASP)</h3>
                <Link to="GNBPURE01004S">
                상세보기 &gt;
                </Link>
                <ul className="text-info">
                  <li>인터넷 및 클라우드를 통한 서비스</li>
                  <li>고객사의 요구에 최적화된 맞춤 솔루션 제공</li>
                  <li>금융업무에 필요한 솔루션 제공</li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <div className="main_banner01-5">
          <div>
            <div className="inner">
              <div className="box-text">
                <h3 className="tit-main01">IT컨설팅</h3>
                <Link to="GNBPURE01005S">
                상세보기 &gt;
                </Link>
                <ul className="text-info">
                  <li>풍부한 금융 IT 경험</li>
                  <li>맞춤형 IT 솔루션 운영 전략 제공</li>
                  <li>보안/리스크/규제 대응</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </Slider>

    );

  };
    
    return (

    <CommonLayout serverTime={new Date().getTime()} appMode="DEV" menuId="MAIN" frameId="MAIN_FRAME">
      <CommonMenu/>

      <section className="sec_main">
        <div className="banner2-area ac-slider01">
          <AcSliderMain />
        </div>
      </section>

      <div className="container">
        <section className="sec_01">
            <div className="banner2-area ac-slider01">
            <AcSlider01 />
            </div>
        </section>
        
        <section className="sec_02">
          <div className="inner">
            <div className="box-left">
              <p className="tit-main01">
                {companyInfo === "(주)지앤비소프텍" ? (
                  <>
                    <span className="fw-bold">{companyInfo}은 </span> <br /> 중, 소형 금융기관에 <br /> 정통한 전문 SI회사 입니다.
                  </>
                ) : companyInfo === "(주)퓨어솔루션" ? (
                  <>
                    <span className="fw-bold">{companyInfo}은 </span> <br /> 금융IT 전문가들로 <br /> 구성된 금융솔루션 <br /> 전문회사 입니다.
                  </>
                ) : (
                  <>
                    <span className="fw-bold">{companyInfo}은 </span> <br /> 금융IT 전문가들로 <br /> 구성된 금융솔루션 <br /> 전문회사 입니다.
                  </>
                )}
              </p>
            </div>

            <div>
              <div className="box-right">
                <ul>
                  <li>
                    <a href="GNBPURE02001S">
                      <dl>
                        <dt>온라인대출</dt>
                        <dd>여신종합시스템</dd>
                      </dl>
                    </a>
                  </li>
                  <li>
                    <a href="GNBPURE02002S">
                      <dl>
                        <dt>스탁론</dt>
                        <dd>주식매입자금 대출을<br />받을 수 있는 시스템</dd>
                      </dl>
                    </a>
                  </li>
                </ul>
              </div>

              <div className="box-right2">
                <ul>
                  <li>
                    <a href="GNBPURE02003S">
                      <dl>
                        <dt>NPL</dt>
                        <dd>무수익 채권 관리 시스템</dd>
                      </dl>
                    </a>
                  </li>
                  <li>
                    <a href="GNBPURE02004S">
                      <dl>
                        <dt>기관<br />연계시스템</dt>
                        <dd>다양한 외부환경과의<br /> 인터페이스를 통한<br /> 업무서비스 제공</dd>
                      </dl>
                    </a>
                  </li>
                  <li>
                    <a href="GNBPURE02000S">
                      <dl>
                        <dt>통합솔루션</dt>
                        <dd>코어뱅킹과 스마트뱅킹의<br />통합된 시스템</dd>
                      </dl>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="sec_03">
          <div className="inner">
            {/* <div className="box-list">
              <div>
                <h2>채용공고</h2>
                <p>(주)지앤비소프텍과 함께할 분들의 많은 지원을 기다립니다.</p>
              </div>
              <ul>
                <li><span>모집대상</span> <span>모집대상 [정규직]금융권 전산업무 개발자 모집(신입/경력)</span></li>
                <li><span>자격요건</span> <span>프로그램 개발(JAVA, ORACLE 앱개발)</span></li>
                <li><span>제출서류</span> <span>자유이력서(희망연봉 기재) / 자기소개서 / 포트폴리오</span></li>
                <li><span>접수방법</span> <span>접수방법 : 이메일 접수<span className="border-bot">(cha@gnbsoftec.co.kr)</span></span></li>
              </ul>
            </div> */}

            {/* <div className="box-quickmenu">
              <ul>
                <li><a href="/company/GNBPC00006S.frm"></a>오시는 길</li>
                <li><a href="/company/GNBPC00003S.frm"></a>사업실적</li>
                <li><a href="/support/GNBPC04002S.frm"></a>공지사항</li>
                <li><a href="/news/GNBPC03001S.frm"></a>NEWS</li>
                <li><a href="/news/GNBPC03003S.frm"></a>Q&A</li>
              </ul>
            </div> */}

            <div className="box-customer">
              <p></p>
              <h2>CUSTOMER</h2>
              <p>{companyInfo}과 함께<br /> 성장하는 고객입니다.</p>
              <ul>
                <li>
                  <a href="https://www.wooribank.com/"><img src="/asset/img/img_woori.png" alt="메인 배경이미지" />우리은행</a>
                  <a href="https://www.kebhana.com/"><img src="/asset/img/img_hana.png" alt="메인 배경이미지" />하나은행</a>
                  <a href="https://www.nhbank.com/"><img src="/asset/img/img_nh.png" alt="메인 배경이미지" />NH농협은행</a>
                  <a href="https://www.jejubank.co.kr/"><img src="/asset/img/img_jeju.png" alt="메인 배경이미지" />제주은행</a>
                  <a href="https://www.kbsavings.com/"><img src="/asset/img/img_kb.png" alt="메인 배경이미지" />KB저축은행</a>

                  <a href="https://www.nhsavingsbank.co.kr/"><img src="/asset/img/img_nhsavingsbank.jpg" alt="메인 배경이미지" />NH저축은행</a>
                  <a href="https://www.ibksb.co.kr/"><img src="/asset/img/img_ibk.jpg" alt="메인 배경이미지" />IBK저축은행</a>
                  <a href="https://www.hanwhasbank.com/"><img src="/asset/img/img_hanwha.jpg" alt="메인 배경이미지" />한화저축은행</a>
                  <a href="https://www.kiwoombank.com/"><img src="/asset/img/img_customer3.png" alt="메인 배경이미지" />키움저축은행</a>

                  <a href="https://www.oksavingsbank.com/"><img src="/asset/img/img_ok.jpg" alt="메인 배경이미지" />OK저축은행</a>
                  <a href="https://www.sbisb.co.kr/"><img src="/asset/img/img_sbi.png" alt="메인 배경이미지" />SBI저축은행</a>
                  <a href="https://www.osb.co.kr/"><img src="/asset/img/img_osb.png" alt="메인 배경이미지" />OSB저축은행</a>
                  <a href="https://www.smartbank.co.kr/"><img src="/asset/img/img_smart.png" alt="메인 배경이미지" />스마트저축은행</a>

                  <a href="https://www.acuonsb.co.kr/"><img src="/asset/img/img_acuon.jpg" alt="메인 배경이미지" />애큐온저축은행</a>
                  <a href="https://www.goryosb.co.kr/"><img src="/asset/img/img_goryo.png" alt="메인 배경이미지" />고려저축은행</a>
                  <a href="https://www.yegaramsb.co.kr/"><img src="/asset/img/img_yegaram.png" alt="메인 배경이미지" />예가람저축은행</a>
                  <a href="https://www.jt-bank.co.kr/"><img src="/asset/img/img_jt.jpg" alt="메인 배경이미지" />JT저축은행</a>

                  <a href="https://www.barosavings.com/main.act"><img src="/asset/img/img_customer9.png" alt="메인 배경이미지" />바로저축은행</a>
                  <a href="https://www.daolsb.com/"><img src="/asset/img/img_daol.jpg" alt="메인 배경이미지" />다올저축은행</a>
                  <a href="https://www.debecbank.co.kr/main.act"><img src="/asset/img/img_customer8.png" alt="메인 배경이미지" />대백저축은행</a>
                  <a href="https://www.fsb.or.kr/index.act"><img src="/asset/img/img_customer5.png" alt="메인 배경이미지" />SB저축은행중앙회</a>
                </li>
                <li>
                  <a href="https://www.moel.go.kr/"><img src="/asset/img/img_moel.jpg" alt="메인 배경이미지" />고용노동부</a>
                  <a href="https://www.ccrs.or.kr/"><img src="/asset/img/img_ccrs.jpg" alt="메인 배경이미지" />신용회복위원회</a>
                  <a href="https://www.comwel.or.kr/"><img src="/asset/img/img_comwel.jpg" alt="메인 배경이미지" />근로복지공단</a>
                </li>
                <li>
                  <a href="https://www.lottecard.co.kr/"><img src="/asset/img/img_lottecard.png" alt="메인 배경이미지" />롯데카드</a>
              {/* <a href="https://www.bccard.com/"><img src="/asset/img/img_bccard.jpg" alt="메인 배경이미지" />비씨카드</a> */}
                  <a href="https://direct.hi.co.kr/"><img src="/asset/img/img_customer1.png" alt="메인 배경이미지" />현대해상</a>
                  <a href="https://www.idbins.com/"><img src="/asset/img/img_customer2.png" alt="메인 배경이미지" />DB손해보험</a>
                  <a href="https://www.nhfire.co.kr/direct/index.nhfire"><img src="/asset/img/img_customer7.png" alt="메인 배경이미지" />NH농협손해보험</a>

                  <a href="https://www.hankookcapital.co.kr/"><img src="/asset/img/img_customer4.png" alt="메인 배경이미지" />한국캐피탈(주)</a>
                  <a href="https://www.ibkc.co.kr/"><img src="/asset/img/img_customer6.png" alt="메인 배경이미지" />IBK캐피탈</a>
                  <a href="https://orix.co.kr/"><img src="/asset/img/img_orix.jpg" alt="메인 배경이미지" />오릭스캐피탈</a>
                </li>
                <li>
                  <a href="https://8percent.kr/"><img src="/asset/img/img_8percent.jpg" alt="메인 배경이미지" />8퍼센트</a>
                  <a href="https://www.niceabc.co.kr/"><img src="/asset/img/imb_niceabc.jpg" alt="메인 배경이미지" />나이스비즈니스플랫폼</a>
                </li>
              </ul>
            </div>
          </div>

        </section>
        
      </div>

      <CommonFooter/>
    </CommonLayout>
  );
}

